/* import __COLOCATED_TEMPLATE__ from './user-nav.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
import TEMPLATE from "./user-nav.hbs";
import { setComponentTemplate } from "@ember/component";
export default setComponentTemplate(TEMPLATE, templateOnlyComponent());